import React, { Component } from 'react';
import { object, func, bool, string } from 'prop-types';
import { Link } from 'react-router';
import { inc } from 'ramda';

// Redux
import { connect } from 'react-redux';
import { closeMainMenu, openMainMenu } from '../../actions/mainMenu/mainMenuActions';

import HeaderBranding from '../HeaderBar/HeaderBranding';
import User from '../User';
import MainMenuList from './MainMenuList';

import cx from 'classnames';
import s from './MainMenu.css';


export class MainMenu extends Component {
  static propTypes = {
    account: object,
    authenticatedPreferences: object,
    dispatch: func,
    isUnauth: bool,
    className: string,
    activeItemKey: string,
    preferences: object,
  };

  constructor(props) {
    super(props);
  };

  // Set a state variable to control show/hide of mobile menu
  handleMobileMenu = (e) => {
    e.preventDefault();
    if (this.props.mainMenu.open) {
      this.props.closeMainMenu();
    } else {
      this.props.openMainMenu();
    }
  };

  // Renders the default Home menu item if auth is true, else show Updox logo
  renderMobileMenuBranding = () => {
    const isUnauth = this.props.isUnauth;

    if (!isUnauth) {
      return (
        <Link
          to="/"
          title="Home"
          className={s.menuMobileButton}
          onClick={this.props.closeMainMenu}
        >
          <div className={s.iconHome}/>
          <p className={s.buttonText}>Home</p>
        </Link>
      );
    }
    return (
      <HeaderBranding />
    );
  };

  renderMobileMenuItem = prefs => {
    const isUnauth = this.props.isUnauth;
    // Display the default Health item if auth is true and the preference(s) is turned on
    if ((prefs.recordsEnabled || prefs.medicationRefillsEnabled) && !isUnauth) {
      return (
        <Link
          to="/health"
          title="Health"
          className={s.menuMobileButton}
          onClick={this.props.closeMainMenu}
        >
          <div className={s.iconHealth}/>
          <p className={s.buttonText}>Health</p>
        </Link>
      );
    }
  };

  renderUnauthMenuItems = prefs => {
    return [
      {
        key: 'login',
        name: 'Home',
        path: '/login',
        visible: true,
        styleObject: {
          button: s.home,
          icon: s.iconHome,
        },
      },
      {
        key: 'forms',
        name: 'Patient Forms',
        path: '/public-forms',
        visible: prefs.formsEnabled,
        styleObject: {
          button: s.forms,
          icon: s.iconForms,
        },
      },
    ];
  };

  renderMenuItems = prefs => {
    return [
      {
        key: 'home',
        name: 'Home',
        path: '/home',
        visible: prefs.homeEnabled,
        styleObject: {
          button: s.home,
          icon: s.iconHome,
        },
      },
      {
        key: 'health',
        name: 'Health',
        path: '/health',
        visible: prefs.recordsEnabled || prefs.medicationRefillsEnabled,
        styleObject: {
          button: s.health,
          icon: s.iconHealth,
        },
      },
      {
        key: 'family',
        name: 'Family',
        path: '/family',
        visible: true,
        styleObject: {
          button: s.family,
          icon: s.iconFamily,
        },
      },
      {
        key: 'messages',
        name: 'Messages',
        path: '/messages',
        visible: prefs.messagesEnabled,
        styleObject: {
          button: s.messages,
          icon: s.iconMessages,
        },
      },
      {
        key: 'appointments',
        name: 'Appointments',
        path: '/appointments',
        visible: prefs.appointmentViewingEnabled || prefs.appointmentSchedulingEnabled || prefs.appointmentWaitlistingEnabled,
        styleObject: {
          button: s.appts,
          icon: s.iconAppts,
        },
      },
      {
        key: 'forms',
        name: 'Forms',
        path: '/forms',
        visible: prefs.formsEnabled,
        styleObject: {
          button: s.forms,
          icon: s.iconForms,
        },
      },
    ];
  };

  render = () => {
    const {
      isUnauth,
      activeItemKey,
      className,
    } = this.props;

    const mobileMenuIsActive = this.props.mainMenu.open;
    const isActiveStyle = mobileMenuIsActive ? s.active : '';
    const whichItems = isUnauth ? this.renderUnauthMenuItems(this.props.preferences) : this.renderMenuItems(this.props.authenticatedPreferences);
    const authStyle = isUnauth ? s.appUnauth : '';

    const accountEnabled = this.props.authenticatedPreferences.accountEnabled;
    const hideLogoutButton = isUnauth ? this.props.preferences.logoutButtonHidden : this.props.authenticatedPreferences.logoutButtonHidden;

    return (
      <nav className={cx(s.component, isActiveStyle, authStyle, className)} id="mainMenu">
        {!isUnauth &&
          <User
            closeMainMenu={this.props.closeMainMenu}
            firstName={this.props.account.firstName}
            lastName={this.props.account.lastName}
            hideLogoutButton={hideLogoutButton}
          />
        }
        <MainMenuList
          accountEnabled={accountEnabled}
          closeMainMenu={this.props.closeMainMenu}
          isUnauth={isUnauth}
          items={whichItems}
          activeItemKey={activeItemKey}
        />
        <nav className={s.menuMobile}>
          <ul className={s.list}>
            <li className={s.listItem}>
              <a
                href=""
                title="Menu"
                className={cx(s.menuMobileButton, isActiveStyle)}
                onClick={this.handleMobileMenu}
              >
                <div className={cx(s.line, s.lineTop, isActiveStyle)}/>
                <div className={cx(s.line, s.lineBottom, isActiveStyle)}/>
                <p className={s.buttonText}>Menu</p>
              </a>
            </li>
            <li className={s.listItem}>
              {this.renderMobileMenuBranding()}
            </li>
            <li className={s.listItem}>
              {this.renderMobileMenuItem(this.props.authenticatedPreferences)}
            </li>
          </ul>
        </nav>
        {mobileMenuIsActive && !isUnauth &&
          <div className={s.overlay}/>
        }
      </nav>
    );
  }
}

const mapStateToProps = state => ({
  account: state.account,
  mainMenu: state.mainMenu,
  authenticatedPreferences: state.authenticatedPreferences,
  preferences: state.preferences,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  closeMainMenu: () => dispatch(closeMainMenu()),
  openMainMenu: () => dispatch(openMainMenu()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);



// WEBPACK FOOTER //
// ./src/components/MainMenu/MainMenu.js